import { Dropdown } from 'primereact/dropdown';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { selectCurrentEmpid } from '../../../pages/login/authSlice';
import { useGetScorecardVersionsBySupervisorQuery } from '../coachingActionPlanSlice';

interface PropTypes {
    setAgentNumber: (e: number) => void;
    scorecardVersionValue: (e: number) => void;
    inputmonth: number;
    setInputMonth: (e: number) => void;
    inputyear: number;
    setInputYear: (e: number) => void;
}

const TLScoreCardFilter = ({
    scorecardVersionValue,
    setAgentNumber,
    inputmonth,
    setInputMonth,
    inputyear,
    setInputYear,
}: PropTypes) => {
    const [scorecardDisable, setScorecardDisable] = useState<boolean>(false);
    const [scorecardVersion, setScorecardVersion] = useState(0);
    const empNum = useSelector(selectCurrentEmpid);
    const { scid } = useParams();

    console.log(inputmonth,inputyear);

    const { data: scorecardVersionsData } = useGetScorecardVersionsBySupervisorQuery(
        empNum?.toString(),
        { skip: !empNum }
    );

    useEffect(() => {
        const currentDate = new Date();
        setInputMonth(currentDate.getMonth() + 1);
        setInputYear(currentDate.getFullYear());
    }, []);

    useEffect(() => {
        setAgentNumber(empNum);
        const versions = scorecardVersionsData?.data;
        if (versions?.length > 0) {
            setScorecardDisable(false);
            if (window.localStorage.TLscorecardVersion) {
                setScorecardVersion(parseInt(window.localStorage.TLscorecardVersion, 10));
                scorecardVersionValue(parseInt(window.localStorage.TLscorecardVersion, 10));
            } else {
                setScorecardVersion(versions[0].scorecard_version_id);
                scorecardVersionValue(versions[0].scorecard_version_id);
            }
        } else {
            setScorecardDisable(true);
        }
    }, [scorecardVersionsData]);

    const ScorecardOnChange = (e: any) => {
        setScorecardVersion(e.value);
        scorecardVersionValue(e.value);
        window.localStorage.TLscorecardVersion = e.value;
    };

    useEffect(() => {
        if (scid) {
            window.localStorage.TLscorecardVersion = scid;
        }
    }, []);

    return (
        <div className="col-md-8">
            <Dropdown
                disabled={scorecardDisable}
                value={scorecardVersion}
                onChange={ScorecardOnChange}
                options={scorecardVersionsData?.data}
                optionValue={'scorecard_version_id'}
                optionLabel={'scorecard_name'}
                placeholder={'No Scorecards'}
                className="custom-dropdown me-3 mb-2"
            />
        </div>
    );
};

export default TLScoreCardFilter;
